import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Input,
  TextArea,
  Form
} from 'semantic-ui-react'

const CardOperativeNoteTemplateUX = (props: any) => {
    return(
      <div
        id="CardOperativeNoteTemplateUX-div-0"
        style={{ margin: "15px",}}>
        <div
          id="CardOperativeNoteTemplateUX-div-1"
          style={{ paddingBottom: "0px", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          
          <label
            id="CardOperativeNoteTemplateUX-label-2"
            style={{ fontWeight: "bold", fontSize: "22px" }}>
            {props.languageUX === "en" ? "Operative Note Template" : "Operative Note Template"}
          </label>
          <div
            id="CardOperativeNoteTemplateUX-div-241">
            {props.iconClose}
          </div>
        </div>
        <hr
          id="CardOperativeNoteTemplateUX-hr-5">
        </hr>
        <div
          id="CardOperativeNoteTemplateUX-div-6"
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "5px 0px", fontWeight: "bold" }}>
          
          <div
            id="CardOperativeNoteTemplateUX-div-242"
            style={{width: "70%" , display: "flex", alignItems: "center"}}>
            
            <div
              id="CardOperativeNoteTemplateUX-div-244"
              style={{width: "90%" }}>
              
              <Input
                fluid={true}
                id="CardOperativeNoteTemplateUX-Input-246"
                onChange={props.onChangeSearchTem}
                placeholder={props.languageUX === "en" ? "Search by Name" : "ค้นหาจากชื่อ"}
                value={props.searchTem}>
              </Input>
            </div>
            <Button
              color="blue"
              id="CardOperativeNoteTemplateUX-Button-245"
              onClick={props.onSearchData}
              style={{ margin: "0px 10px", }}>
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
          </div>
          <Button
            color="green"
            id="CardOperativeNoteTemplateUX-Button-247"
            onClick={props.onOpenFormTem}>
            {props.languageUX === "en" ? "Add New Template" : "เพิ่ม Template ใหม่"}
          </Button>
        </div>
        <div
          id="CardOperativeNoteTemplateUX-div-248"
          style={{ display: props.styleFormTem ? "block" : "none" , padding:"10px" , margin: "10px 0px", fontWeight: "bold", backgroundColor: "rgba(217,217,217,217)" }}>
          
          <div
            id="CardOperativeNoteTemplateUX-div-249"
            style={{width: "100%"}}>
            
            <Input
              fluid={true}
              id="CardOperativeNoteTemplateUX-Input-252"
              onChange={props.onChangeTemName}
              placeholder="เขียนชื่อ Template"
              value={props.temName}>
            </Input>
          </div>
          <Form
            id="CardOperativeNoteTemplateUX-Form-258">
            <TextArea
              id="CardOperativeNoteTemplateUX-TextArea-257"
              onChange={props.onChangeNoteName}
              rows={7}
              style={{margin: "10px 0px"}}
              value={props.noteName}>
            </TextArea>
          </Form>
          <div
            id="CardOperativeNoteTemplateUX-div-251">
            
            <Button
              color="green"
              id="CardOperativeNoteTemplateUX-Button-254"
              onClick={props.onSaveForm}
              style={{ width: "100px"}}>
              {props.languageUX === "en" ? "record" : "บันทึก"}
            </Button>
            <Button
              color="red"
              id="CardOperativeNoteTemplateUX-Button-255"
              onClick={props.onCloseForm}
              style={{margin: "0px 5px", width: "100px"}}>
              {props.languageUX === "en" ? "turn off" : "ปิด"}
            </Button>
          </div>
        </div>
        <div
          id="CardOperativeNoteTemplateUX-div-256"
          style={{padding:"10px" , margin: "10px 0px", fontWeight: "bold", backgroundColor: "rgba(224,224,224,224)", height: "500px" ,overflowX: "auto", overflowY: "scroll"}}>
          {props.temData}
        </div>
      </div>
    )
}

CardOperativeNoteTemplateUX.displayName = "CardOperativeNoteTemplateUX";
export default React.memo(CardOperativeNoteTemplateUX)

export const screenPropsDefault = {"debug":true,"language":"TH","showSupplyList":false}

/* Date Time : Tue Oct 21 2025 10:51:25 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\",}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"0px\", display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Operative Note Template",
          "valueEN": "Operative Note Template"
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"22px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-hr-5"
        }
      },
      "seq": 5,
      "void": true
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", margin: \"5px 0px\", fontWeight: \"bold\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 241,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.iconClose"
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-241"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-242"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70%\" , display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 244,
      "name": "div",
      "parent": 242,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-244"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\" }"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 245,
      "name": "Button",
      "parent": 242,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-Button-245"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearchData"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\", }"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 246,
      "name": "Input",
      "parent": 244,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-Input-246"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearchTem"
        },
        "placeholder": {
          "type": "value",
          "value": "ค้นหาจากชื่อ",
          "valueEN": "Search by Name"
        },
        "value": {
          "type": "code",
          "value": "props.searchTem"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 247,
      "name": "Button",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม Template ใหม่",
          "valueEN": "Add New Template"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-Button-247"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenFormTem"
        },
        "size": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-248"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.styleFormTem ? \"block\" : \"none\" , padding:\"10px\" , margin: \"10px 0px\", fontWeight: \"bold\", backgroundColor: \"rgba(217,217,217,217)\" }"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": null,
      "id": 249,
      "name": "div",
      "parent": 248,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-249"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 248,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-251"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 252,
      "name": "Input",
      "parent": 249,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-Input-252"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeTemName"
        },
        "placeholder": {
          "type": "value",
          "value": "เขียนชื่อ Template"
        },
        "value": {
          "type": "code",
          "value": "props.temName"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 254,
      "name": "Button",
      "parent": 251,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-Button-254"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveForm"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100px\"}"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 255,
      "name": "Button",
      "parent": 251,
      "props": {
        "children": {
          "type": "value",
          "value": "ปิด",
          "valueEN": "turn off"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-Button-255"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseForm"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 5px\", width: \"100px\"}"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.temData"
        },
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-div-256"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"10px\" , margin: \"10px 0px\", fontWeight: \"bold\", backgroundColor: \"rgba(224,224,224,224)\", height: \"500px\" ,overflowX: \"auto\", overflowY: \"scroll\"}"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 257,
      "name": "TextArea",
      "parent": 258,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-TextArea-257"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNoteName"
        },
        "rows": {
          "type": "code",
          "value": "7"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"10px 0px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.noteName"
        }
      },
      "seq": 257,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 258,
      "name": "Form",
      "parent": 248,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperativeNoteTemplateUX-Form-258"
        }
      },
      "seq": 251,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": true,
  "name": "CardOperativeNoteTemplateUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "debug": true,
    "language": "TH",
    "showSupplyList": false
  },
  "width": 75
}

*********************************************************************************** */
